import SSRIcon from "@ingka/ssr-icon";
import notVisiblePath from "@ingka/ssr-icon/paths/visibility-hide";
import visiblePath from "@ingka/ssr-icon/paths/visibility-show";
import Text from "@ingka/text";
import { SELECT_ALL } from "./constants";

const MetadataTitle = ({
  assetCount,
  handleChangeVisible,
  visibility,
}: {
  assetCount: number;
  handleChangeVisible: (metadataField: string) => void;
  visibility: string[];
}) => {
  return (
    <div className="flex items-start">
      <button
        type="button"
        className="border-0 bg-transparent p-0 leading-none"
        onClick={() => handleChangeVisible(SELECT_ALL)}
        aria-label={
          visibility.includes(SELECT_ALL)
            ? "Show all metadata"
            : "Hide all metadata"
        }
      >
        <SSRIcon
          paths={visibility.includes(SELECT_ALL) ? notVisiblePath : visiblePath}
        />
      </button>
      <div className="ms-space25 flex flex-col">
        <Text headingSize="s">Metadata overview</Text>
        <Text bodySize="m">Assets in total ({assetCount})</Text>
      </div>
    </div>
  );
};

export default MetadataTitle;
